<template>
  <div class="flex flex-col gap-x-8 gap-y-8 py-6 md:flex-row md:gap-y-0">
    <div class="flex flex-row gap-x-10 bg-[#6dbd77] px-9 py-6 md:w-2/3">
      <div>
        <h3 class="text-3xl font-bold text-white">Quality Content,</h3>
        <h3 class="text-3xl font-bold text-white">Straight To Your Inbox!</h3>
        <p class="font-semibold text-white">Subscribe for the latest blogs, podcasts, webinars, and events!</p>
        <form class="relative mt-9 flex items-center justify-between rounded-full border xl:w-[30rem]">
          <input
            placeholder="Subscribe for Latest Posts"
            class="w-full rounded-full bg-[#6dbd77] px-4 py-4 outline-none placeholder:text-xs placeholder:text-white placeholder:md:text-base"
          />
          <button
            type="submit"
            class="-ml-52 hidden w-2/5 rounded-full bg-[#3a3a3c] py-4 font-semibold text-white lg:block"
          >
            Subscribe
          </button>
          <button
            class="absolute right-[2%] h-[2.5rem] w-[2.5rem] rounded-full bg-[#3a3a3c] text-2xl font-bold text-white lg:hidden"
          >
            >
          </button>
        </form>
      </div>
      <NuxtImg
        loading="lazy"
        src="/images/components/newsletter-girl.webp"
        class="hidden aspect-[116/100] h-44 w-[12.76rem] lg:block"
        width="271"
        height="234"
        alt="Newsletter"
      />
    </div>
    <div class="bg-[#f2b642] px-9 py-6 md:w-1/3">
      <h3 class="text-3xl font-semibold text-black">Write a Blog</h3>
      <p class="font-medium">If you have experience in CS and</p>
      <p class="font-medium">a flair for writing, we’d love to</p>
      <p class="font-medium">feature you.</p>
      <p class="font-bold">Write to us on</p>
      <a href="https://mail.google.com/mail/?view=cm&fs=1&to=hello@zapscale.com" target="_blank" alt="newsletter email">
        hello@zapscale.com
      </a>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
